import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import Loading from "../../common/Loading";
import { RETAINER_OR_CLIENT_CARE_CONTRACTS_COLUMNS } from "./columns";

const RetainerOrClientCareContractsList = ({
  data,
  loading,
  sorted,
  onRowClick = () => {},
  onSortedChange
}) => {
  if (loading)
    return (
      <div className="loading">
        <Loading />
      </div>
    );

  return data && data.length ? (
    <div className="content-wrapper">
      <ReactTable
        className="-highlight"
        data={data}
        columns={RETAINER_OR_CLIENT_CARE_CONTRACTS_COLUMNS}
        manual
        sorted={sorted}
        onSortedChange={onSortedChange}
        defaultSorted={[{ id: "name", desc: false }]}
        getTrProps={(state, rowInfo) => ({
          onClick: () => onRowClick(rowInfo)
        })}
        showPagination={false}
      />
    </div>
  ) : (
    <div className="loading">
      <h4 style={{ opacity: 0.15 }}>No Data</h4>
    </div>
  );
};

RetainerOrClientCareContractsList.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func,
  onSortedChange: PropTypes.func,
  sorted: PropTypes.array
};

export default RetainerOrClientCareContractsList;
